import React from 'react';
import useFadeInOnScroll from '../hooks/useFadeInOnScroll';
import './FadeInSection.css';

// Usage: Wrap any content in <FadeInSection>...</FadeInSection>
export default function FadeInSection({ children, className = '', ...props }) {
  const ref = useFadeInOnScroll();
  return (
    <div ref={ref} className={`fade-in-section ${className}`} {...props}>
      {children}
    </div>
  );
}
